import { ReactNode } from "react";

import { formatPointsSimple } from "@vericus/cadmus-common";
import { Text, vars } from "@vericus/cadmus-ui";

import clsx from "clsx";

import squigglyNoteIcon from "@/assets/illustrations/squiggly-note.svg";
import feedbackImg from "@/assets/illustrations/students-discussing.png";
import { ProvisionalFeedbackPill } from "@/features/feedback/components/provisional-feedback-pill";
import { FeedbackLevel } from "@/generated/graphql";

import * as styles from "./feedback-results.css";

interface Props {
  isProvisional: boolean;
  feedbackViewLevel: FeedbackLevel;
  finalGrade: number | null | undefined;
  maxGrade: number;
  /** Optional "Detailed score breakdown" disclosure rendered at the bottom. */
  breakdown?: ReactNode;
}

export function FeedbackResults({
  isProvisional,
  maxGrade,
  feedbackViewLevel,
  finalGrade,
  breakdown,
}: Props) {
  const finalReleased = finalGrade !== undefined && finalGrade !== null;
  const showMarks = feedbackViewLevel !== FeedbackLevel.Feedback;
  const getScore = (score?: number | null) => {
    if (score === null || score === undefined) return "--";
    return formatPointsSimple(score);
  };

  return (
    <div className={clsx(styles.feedbackOverviewResults, styles.feedbackLeft)}>
      <Text kind="displayThree" style={{ fontSize: "2rem" }}>
        {finalReleased ? (
          <>
            <span style={{ color: vars.colors.lilac500 }}>
              {isProvisional && "Provisional "}Feedback
            </span>{" "}
            has been released
          </>
        ) : (
          <>
            <span style={{ color: vars.colors.lilac500 }}>Draft Feedback</span>{" "}
            is available
          </>
        )}
      </Text>
      <div className={styles.feedbackResults}>
        <img src={feedbackImg} height={140} width={140} alt="" />
        {isProvisional && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ProvisionalFeedbackPill label={"Provisional Feedback"} />
          </div>
        )}
        <div className={clsx(styles.gradeContent, styles.gradeResults)}>
          <img src={squigglyNoteIcon} width={39} height={32} alt="" />
          <div>
            <Text kind="headingFour">
              {finalReleased ? (
                <>
                  {showMarks ? getScore(finalGrade) : "xx.xx"}/{maxGrade}
                </>
              ) : (
                "-"
              )}
            </Text>
            <Text kind="label" bold>
              Grade
            </Text>
          </div>
        </div>
        {breakdown}
      </div>
    </div>
  );
}
